export default __webpack_public_path__ + "static/media/B15C.b7c9a8b0.jpg";